// extracted by mini-css-extract-plugin
export default {"title":"Faq_title__hblpz","nav":"Faq_nav__ZTPoY","btn":"Faq_btn__-jAmq","active":"Faq_active__6pfm8","dropdown":"Faq_dropdown__kzIlR","list":"Faq_list__W81BC"};